import React from "react";
import { FiMaximize, FiRotateCcw, FiRotateCw, FiType, FiZoomIn, FiZoomOut } from "react-icons/fi";
import editorStore from "../../stores/EditorStore";
import { BANNER_FONTS } from "./bannerConfig";

const ToolButton: React.FC<{ label: string; onClick: () => void; children: React.ReactNode }> = ({ label, onClick, children }) => (
  <button
    onClick={onClick}
    className="flex min-w-[56px] flex-col items-center gap-0.5 rounded px-2 py-1 text-[10px] text-white/90 hover:bg-white/10"
  >
    <span className="text-base">{children}</span>
    {label}
  </button>
);

const Divider = () => <div className="mx-2 h-8 w-px bg-white/25" />;

const addText = () => {
  const { width, height } = editorStore;
  const fontSize = Math.round(height * 0.2);
  const boxWidth = width * 0.6;
  editorStore.activePage.addElement({
    type: "text",
    text: "Your Text",
    fontFamily: BANNER_FONTS[0],
    fontSize,
    fontWeight: "bold",
    textAlign: "center",
    width: boxWidth,
    x: (width - boxWidth) / 2,
    y: (height - fontSize * 1.16) / 2,
  });
};

const toggleFullScreen = () =>
  document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen();

const BannerToolbar: React.FC = () => (
  <div className="flex h-12 items-center bg-[#625e5c] px-4 font-jakarta">
    <div className="flex flex-1 justify-center">
      <ToolButton label="Add Text" onClick={addText}><FiType /></ToolButton>
    </div>
    <ToolButton label="Undo" onClick={() => editorStore.history.undo()}><FiRotateCcw /></ToolButton>
    <ToolButton label="Redo" onClick={() => editorStore.history.redo()}><FiRotateCw /></ToolButton>
    <Divider />
    <ToolButton label="Zoom Out" onClick={() => editorStore.zoom(1 / 1.25)}><FiZoomOut /></ToolButton>
    <ToolButton label="Zoom In" onClick={() => editorStore.zoom(1.25)}><FiZoomIn /></ToolButton>
    <Divider />
    <ToolButton label="Full Screen" onClick={toggleFullScreen}><FiMaximize /></ToolButton>
  </div>
);

export default BannerToolbar;
